export default __webpack_public_path__ + "static/media/big3.ff2ec99b.jpg";